import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDelayReasonClientAvailableColumns } from './api';

export const path = '/delay-reason-client/list';

const PageDelayReasonClient: React.FC = (props) => {
  const DelayReasonClient = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDelayReasonClientAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DelayReasonClient {...props} />;
};

export default PageDelayReasonClient;
